import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _typeof from "@babel/runtime/helpers/typeof";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { RouterService } from '@tokamakjs/common';
import { Module, Scope } from '@tokamakjs/injection';
import { RouterHookService } from './router.hook-service';

var RouterModule = function RouterModule() {
  _classCallCheck(this, RouterModule);
};

RouterModule = __decorate([Module({
  providers: [{
    provide: RouterService,
    useClass: RouterHookService,
    scope: Scope.TRANSIENT
  }],
  exports: [RouterService]
})], RouterModule);
export { RouterModule };